var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"primary","label":"Loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }